import Component from '../abstracts/Component';

export default class MiniCartComponent extends Component {

  get SELECTORS() {
    return {
      minicartBtn: '[data-minicart-button]',
      minicartContent: '[data-minicart-content]',
      minicartContentNotify: '[data-minicartnotification-content]',
      minicartCount: '[data-mini-cart-qty]',
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
  }

  readDOM() {
    return {
      minicartBtn: this.$component.querySelector(this.SELECTORS.minicartBtn),
      minicartContent: this.$component.querySelector(this.SELECTORS.minicartContent),
      minicartCount: this.$component.querySelector(this.SELECTORS.minicartCount),
      minicartContentNotify: this.$component.querySelector(this.SELECTORS.minicartContentNotify),
    }
  }

  async updateMinicart() {
    const url = this.dom.minicartBtn.dataset.urlMiniCart;
    await fetch(url)
    .then(response => {
      return response.text();
    })
    .then(text => {
      const htmlResponse = new DOMParser().parseFromString(text, 'text/html');
      this.dom.minicartContent.innerHTML = htmlResponse.querySelector(this.SELECTORS.minicartContent).innerHTML;
      this.dom = this.readDOM();
    })
    .catch(error => console.error(error));
  }

  openQuickCartNotification(productCode) {
    const url = this.dom.minicartBtn.dataset.urlQuickCart+"?productCode="+productCode;
    fetch(url, { method: 'POST' })
    .then(response => {
      return response.text();
    })
    .then(text => {
      const htmlResponse = new DOMParser().parseFromString(text, 'text/html');
      this.dom.minicartContentNotify.innerHTML = htmlResponse.querySelector(this.SELECTORS.minicartContent).innerHTML;
      this.dom.minicartContentNotify.classList.add("--open");
      this.dom.minicartContent.classList.add("--hidden");
      if (window.innerWidth > 1023) {
        setTimeout(() => {
          this.dom.minicartContentNotify.classList.remove("--open");
          this.dom.minicartContent.classList.remove("--hidden");
          this.dom.minicartContentNotify.innerHTML = '';
        }, 3000);
      }
      const closeButton = this.dom.minicartContentNotify.querySelector(".icon-close");
      if (closeButton) {
        closeButton.addEventListener("click", () => {
          this.dom.minicartContentNotify.classList.remove("--open");
          this.dom.minicartContent.classList.remove("--hidden");
        });
      }
    })
    .catch((error) => {
      console.error(error);
    });
  }

  bindEvents() {
    // update mini cart content + cart counter
    this.$on(this.$customEvents.PRODUCT_EVENTS.addedtocart, ({event, payload}) => {
      const newCartQty = parseInt(this.dom.minicartCount.dataset.miniCartQty, 10) + 1;
      //first time remove --hidden
      this.dom.minicartCount.classList.remove("--hidden");

      this.dom.minicartCount.classList.remove("--show");

      this.dom.minicartCount.classList.add("--go-up");
      //set new counter
      setTimeout(() => {
        this.dom.minicartCount.dataset.miniCartQty = newCartQty;
        this.dom.minicartCount.innerHTML = newCartQty;
        this.dom.minicartCount.classList.remove("--go-up");
        this.dom.minicartCount.classList.add("--go-down");
        setTimeout(() => {
          this.dom.minicartCount.classList.remove("--go-down");
          this.dom.minicartCount.classList.add('--show');
        },300);
      },300);

      this.updateMinicart();
    });

    // show quick cart notification
    this.$on(this.$customEvents.PRODUCT_EVENTS.addedtocart, ({event, payload}) => {
      this.openQuickCartNotification(payload.productCode);
    });
  }

  render() {
    this.log('Rendering...');
    this.dom = this.readDOM();
    // on page load retrieve the mini cart content
    this.updateMinicart().then( res => {
      this.bindEvents();
    });
  }

}
